import styled, { css } from "styled-components";
import queries, { devices } from "utils/responsivenessHelper";
import colours from "assets/colours";

const Container = styled.div`
  min-width: 655px;
  padding: 4.5em 6em;
  overflow: auto;
  ${queries.portrait({ minWidth: "100vw", padding: "6em 1em" }, devices.phone)}
`;

const DashBorder = styled.div`
  border: 2px dashed #ced2e3;
  box-sizing: border-box;
  border-radius: 25px;
  transform: matrix(1, 0, 0, 1, 0, 0);

  ${({ uploaded, image }) => {
    if (uploaded && !image) {
      return css`
        background: ${colours.zltoLightBlueFaded};
        border: 2px solid ${colours.zltoLightBlue};
      `;
    }

    if (uploaded && image) {
      return css`
        border: none;
      `;
    }
  }}
`;

export { Container, DashBorder };
